export class TimeLockTypes {

    public static PK = 'PK';
    public static PKH = 'PKH';

}
